import { DialogContent, Stack, Theme, Typography } from '@mui/material'
import styled from 'styled-components'

export const ContentContainer = styled(DialogContent)`
  padding: 0px !important;
  min-height: 460px !important;
`

export const TabsTitle = styled(Typography)<{
  selected: boolean
  theme: Theme
}>`
  font-size: 15px;
  font-weight: ${({ selected }) =>
    selected ? '700 !important' : '300 !important'};
  color: ${({ selected, theme }) =>
    selected ? theme.palette.primary.main : theme.palette.common.black};
  cursor: pointer;
`

export const TwoColumnInputs = styled(Stack)``

export const FooterContainer = styled(DialogContent)`
  padding: 0px !important;
`
